module.exports = __webpack_public_path__ + "static/antd-datepicker-disabled-8941edfda20b5f01f8f19815410dbc92.png";